var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersPageArtWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 554.076,
    height: 255.325,
    viewBox: "0 0 554.076 255.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_26",
    "data-name": "Artwork 26",
    transform: "translate(277.038 127.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51030",
    "data-name": "Group 51030",
    transform: "translate(-277.038 -127.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143233",
    "data-name": "Path 143233",
    d: "M53.791,200.513a31.983,31.983,0,0,0,.923,16.622c.223.659,4.619,13.043,16.222,17.792,2.535,1.038,5.963,2.047,9.128.686,2.882-1.239,4.737-5.073,3-7.682-1.91-2.863-6.8-2.111-8.7.757s-1.4,6.751.03,9.88c4.524,9.885,16.861,14.179,27.638,12.753,10.838-1.432,18.72-6.257,22.143-9.176",
    transform: "translate(-4.065 -14.897)",
    fill: "none",
    stroke: "#d0d0d0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.847,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143234",
    "data-name": "Path 143234",
    d: "M101.15,47.632c-.406,13.607-1.128,28.839-9.595,38.048C85.321,92.46,76.428,94.165,68.4,97.329,40.305,108.394,19.78,142.185,19.849,177.25S40.574,245.993,68.708,256.9h81.807V26.513Z",
    transform: "translate(-1.519 -1.579)",
    fill: "#0e475c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143235",
    "data-name": "Path 143235",
    d: "M492.859,254.71s54.386-59.326,9.568-126.74c-38.562-58-101.705-27.042-136.649-42.382-18.024-7.912-34.168-16.786-74.8-53.995C220.548-32.9,56.137-.571,88.965,132.417c14.946,60.549-34.616,62.049-2.573,122.42Z",
    transform: "translate(-5.769 0.488)",
    fill: "#0e475c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51006",
    "data-name": "Group 51006",
    transform: "translate(473.595 59.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51005",
    "data-name": "Group 51005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143236",
    "data-name": "Path 143236",
    d: "M552.622,254.009c6.214-34.1,4.854-46.3-11.793-74.133s-18.236-79.634-24.51-64.441-5.431,53.345,14.235,71.859,22.312,26.8,23.48,34.341-2.808,30.7-2.808,30.7Z",
    transform: "translate(-512.848 -68.055)",
    fill: "#9cd499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143237",
    "data-name": "Path 143237",
    d: "M555.735,232.036c.01-.131.019-.26.029-.391-.365-2.8-2.34-17.187-5.073-22.864-3.035-6.3-16.34-17.272-20.074-31.044s-9.654-24.446-13.538-33.146c-5.128-11.486-2.325-26.755,1.914-31.715a1.036,1.036,0,0,0-.31-.142l-1.407.851a10.006,10.006,0,0,0-.955,1.853c-6.275,15.193-5.431,53.345,14.234,71.859s22.313,26.8,23.481,34.341a44.2,44.2,0,0,1,0,8.749Z",
    transform: "translate(-512.848 -68.057)",
    fill: "#74b570"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143238",
    "data-name": "Path 143238",
    d: "M546.157,244.292c4.624-40.074,3.083-53.946-5.857-86.006s49.322-105.118,47.472-92.479-8.015,44.081-24.044,63.81-17.262,35.759-14.18,52.714-.617,56.411-.617,56.411l-1.85,7.09Z",
    transform: "translate(-514.878 -64.354)",
    fill: "#9cd499"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50996",
    "data-name": "Group 50996",
    transform: "translate(27.326 4.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143239",
    "data-name": "Path 143239",
    d: "M548.521,228.011h-.016a.386.386,0,0,1-.371-.4c0-.124.464-12.477.233-22.617s-2.981-27.542-4.654-33.516c-1.523-5.44-3.439-23.684,5.861-42.524a244.405,244.405,0,0,1,13.448-23.529c5.058-8.115,11.353-18.217,21.34-36.01a.387.387,0,0,1,.674.379c-10,17.809-16.3,27.919-21.358,36.042a243.5,243.5,0,0,0-13.411,23.461c-9.193,18.622-7.31,36.612-5.81,41.973,1.683,6.011,4.451,23.5,4.683,33.707.231,10.165-.229,22.541-.234,22.664A.387.387,0,0,1,548.521,228.011Z",
    transform: "translate(-542.439 -69.216)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143240",
    "data-name": "Path 143240",
    d: "M547.51,265.09c2.774-26.819,3.239-13.592-8.283-50.032C526.04,173.353,573.1,136.328,580.8,151.433s16.645,62.577,13.254,61.036-25.894-45.623-26.511-43.774-30.518,17.263-29.285,32.985S550.9,242.37,550.9,242.37l-.308,23.028Z",
    transform: "translate(-514.69 -70.756)",
    fill: "#9cd499"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50997",
    "data-name": "Group 50997",
    transform: "translate(21.833 76.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143241",
    "data-name": "Path 143241",
    d: "M550.561,265.054l-.039,0-3.083-.308a.383.383,0,0,1-.261-.14.389.389,0,0,1-.085-.284c.32-3.1.617-5.708.854-7.8,1.291-11.386,1.291-11.386-2.243-21.141-1.6-4.408-3.784-10.444-6.878-20.23a49.859,49.859,0,0,1-1.778-22.543,57.8,57.8,0,0,1,6.871-19.737c6.1-10.908,15.709-20.276,24.471-23.868,6.089-2.5,10.728-1.684,12.724,2.228,3.271,6.413,7.182,19.54,10.462,35.117,1.893,8.991,4.675,24.647,3.095,26.3a.684.684,0,0,1-.806.147c-1.85-.84-7.975-11.649-16.426-26.827-4.238-7.609-8.609-15.462-9.791-16.816a31.272,31.272,0,0,1-4.165,3.044c-8.376,5.681-25.8,17.5-24.869,29.428,1.214,15.472,12.492,40.311,12.605,40.56a.394.394,0,0,1,.035.165l-.308,22.328a.388.388,0,0,1-.387.382Zm-2.658-1.042,2.276.227.3-21.82c-.711-1.575-11.447-25.574-12.637-40.742-.971-12.373,16.709-24.365,25.206-30.128a28.486,28.486,0,0,0,4.1-3.019.45.45,0,0,1,.385-.309c.748-.069,2.226,2.365,10.577,17.364,5.994,10.764,14.185,25.476,16.03,26.479.141-.232.561-1.5-.255-8-.589-4.707-1.671-10.9-3.045-17.436-3.271-15.57-7.167-28.672-10.419-35.048-1.792-3.509-6.071-4.19-11.742-1.864-15.365,6.3-38.909,34.242-29.12,65.2,3.089,9.771,5.273,15.8,6.868,20.2,3.6,9.924,3.6,9.924,2.285,21.491C548.477,258.713,548.207,261.094,547.9,264.012Z",
    transform: "translate(-536.491 -147.572)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143242",
    "data-name": "Path 143242",
    d: "M557.17,272.72H543.182c-.962,0-1.821-.547-1.912-1.227l-4.7-35.338a2.509,2.509,0,0,1,2.4-3h22.411a2.508,2.508,0,0,1,2.4,3l-4.7,35.338C558.991,272.174,558.132,272.72,557.17,272.72Z",
    transform: "translate(-514.662 -77.274)",
    fill: "#7bcee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143243",
    "data-name": "Path 143243",
    d: "M556.773,271.813h-2c-.98,0-1.768-.567-1.752-1.273l.708-30.524a2.849,2.849,0,0,1,2.766-2.8h3.038a2.443,2.443,0,0,1,2.4,2.8l-3.245,30.524C558.614,271.246,557.753,271.813,556.773,271.813Z",
    transform: "translate(-515.923 -77.585)",
    fill: "#a2dff2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50998",
    "data-name": "Group 50998",
    transform: "translate(24.038 97.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143244",
    "data-name": "Path 143244",
    d: "M540.778,220.294l.247-.43a88.633,88.633,0,0,1-2.148-9.575A48.836,48.836,0,0,0,540.778,220.294Z",
    transform: "translate(-538.878 -172.757)",
    fill: "#74b570"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143245",
    "data-name": "Path 143245",
    d: "M540.789,191.352a28.791,28.791,0,0,0-1.768,6.98c4.13-13.556,27.125-25.794,28.618-27.857l.265-.52C559.268,167.543,545.458,179.681,540.789,191.352Z",
    transform: "translate(-538.889 -169.646)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50999",
    "data-name": "Group 50999",
    transform: "translate(24.617 82.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143246",
    "data-name": "Path 143246",
    d: "M594.278,212.107a.388.388,0,0,1-.376-.295l-4.178-17c-3.263-13.32-7.324-29.9-11.881-37.276-.752-1.217-4.034-2.862-8.682-2.534-6.283.445-18.4,4.785-28.914,28.861a.387.387,0,1,1-.709-.309c10.682-24.449,23.109-28.866,29.568-29.324,5.023-.353,8.52,1.481,9.4,2.9,4.622,7.483,8.528,23.429,11.974,37.5l4.178,17a.387.387,0,0,1-.283.468A.4.4,0,0,1,594.278,212.107Z",
    transform: "translate(-539.506 -154.188)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51000",
    "data-name": "Group 51000",
    transform: "translate(64.648 88.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143247",
    "data-name": "Path 143247",
    d: "M585.343,190.433l-.045,0a.387.387,0,0,1-.34-.429,90.919,90.919,0,0,0-2.092-28.8.387.387,0,1,1,.751-.187,91.762,91.762,0,0,1,2.109,29.082A.387.387,0,0,1,585.343,190.433Z",
    transform: "translate(-582.854 -160.715)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51001",
    "data-name": "Group 51001",
    transform: "translate(62.43 85.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143248",
    "data-name": "Path 143248",
    d: "M580.841,181.526l-.046,0a.387.387,0,0,1-.339-.429c.016-.128,1.5-12.922.465-23.493a.387.387,0,0,1,.771-.075c1.042,10.655-.453,23.529-.468,23.658A.387.387,0,0,1,580.841,181.526Z",
    transform: "translate(-580.453 -157.176)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51002",
    "data-name": "Group 51002",
    transform: "translate(47.725 23.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143249",
    "data-name": "Path 143249",
    d: "M564.916,107.717a.387.387,0,0,1-.167-.736A44.121,44.121,0,0,0,582.315,89.64a.387.387,0,0,1,.682.367,44.931,44.931,0,0,1-17.913,17.671A.373.373,0,0,1,564.916,107.717Z",
    transform: "translate(-564.529 -89.437)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51003",
    "data-name": "Group 51003",
    transform: "translate(39.556 43.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143250",
    "data-name": "Path 143250",
    d: "M556.069,123.443a.387.387,0,0,1-.078-.766c.09-.018,9.149-1.96,19.908-10.659a.387.387,0,0,1,.487.6c-10.917,8.826-20.147,10.8-20.239,10.816A.382.382,0,0,1,556.069,123.443Z",
    transform: "translate(-555.682 -111.933)",
    fill: "#74b570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51004",
    "data-name": "Group 51004",
    transform: "translate(32.554 60.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143251",
    "data-name": "Path 143251",
    d: "M548.738,138.4c-.158,0-.253-.006-.28-.008a.387.387,0,0,1,.056-.771c.063,0,6.306.344,16.312-7.16a.387.387,0,1,1,.464.619C556.1,137.972,550.09,138.4,548.738,138.4Z",
    transform: "translate(-548.1 -130.384)",
    fill: "#74b570"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51019",
    "data-name": "Group 51019",
    transform: "translate(292.555 61.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51014",
    "data-name": "Group 51014",
    transform: "translate(8.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51012",
    "data-name": "Group 51012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143252",
    "data-name": "Path 143252",
    d: "M441.715,178.692a247.79,247.79,0,0,1,2.863-30.4c2.054-11.872,3.9-18.7,3.923-18.775.271-1.044,4.178-5.268,12.865-5.138s7.862,5.671,7.862,5.671h0a1.8,1.8,0,0,1-.062.492,265.9,265.9,0,0,0-7.713,66.528c0,.524.064,1.43.027,2.033,0,0-20.13.519-20.135,0C440.642,195.837,440.984,186.8,441.715,178.692Z",
    transform: "translate(-335.201 -70.955)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143253",
    "data-name": "Path 143253",
    d: "M439,196.882c.006.52.281.936.615.936h.008c.334-.008.6-.425.6-.936h17.252c.006.52.281.936.615.936h.008c.341-.008.611-.438.608-.964a260.351,260.351,0,0,1,1.431-29.471,231.621,231.621,0,0,1,6.593-36.845,1.794,1.794,0,0,0,.063-.492s.824-5.54-7.862-5.671-12.6,4.095-12.866,5.139c-.016.054-1.062,3.922-2.454,10.876-.461,2.3-.959,4.945-1.469,7.9a248.2,248.2,0,0,0-2.863,30.4C438.557,186.8,438.3,193.62,439,196.882Z",
    transform: "translate(-335.019 -70.955)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143254",
    "data-name": "Path 143254",
    d: "M456.155,203.448H388.52s1.575-6.374,40.745-5.424C456.985,198.7,456.155,203.448,456.155,203.448Z",
    transform: "translate(-331.187 -76.585)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51007",
    "data-name": "Group 51007",
    transform: "translate(119.008 127.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143255",
    "data-name": "Path 143255",
    d: "M466.773,270.564c-7.842-39.7-5.826-64.06-5.816-64.367.02-.611-1.106-1.166-1.713-1.187s-3.32-.18-3.633.343c-.411.685-1.99,30.7,9.7,65.211Z",
    transform: "translate(-455.307 -204.975)",
    fill: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51008",
    "data-name": "Group 51008",
    transform: "translate(67.323 127.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143256",
    "data-name": "Path 143256",
    d: "M399.338,270.564c7.842-39.7,5.826-64.06,5.816-64.367-.019-.611,1.106-1.166,1.713-1.187s3.32-.18,3.633.343c.411.685,1.99,30.7-9.7,65.211Z",
    transform: "translate(-399.338 -204.975)",
    fill: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51009",
    "data-name": "Group 51009",
    transform: "translate(54.808 127.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143257",
    "data-name": "Path 143257",
    d: "M385.786,270.564c7.842-39.7,5.825-64.06,5.816-64.367-.02-.611,1.106-1.166,1.712-1.187s3.321-.18,3.634.343c.41.685,1.989,30.7-9.7,65.211Z",
    transform: "translate(-385.786 -204.975)",
    fill: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51010",
    "data-name": "Group 51010",
    transform: "translate(106.409 127.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143258",
    "data-name": "Path 143258",
    d: "M453.129,270.564c-7.842-39.7-5.825-64.06-5.815-64.367.019-.611-1.107-1.166-1.713-1.187s-3.321-.18-3.634.343c-.41.685-1.989,30.7,9.7,65.211Z",
    transform: "translate(-441.663 -204.975)",
    fill: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29095",
    "data-name": "Rectangle 29095",
    d: "M1.386,0H69.021a1.386,1.386,0,0,1,1.386,1.386V2.3a1.385,1.385,0,0,1-1.385,1.385H1.386A1.386,1.386,0,0,1,0,2.3V1.386A1.386,1.386,0,0,1,1.386,0Z",
    transform: "translate(126.314 128.898) rotate(180)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51011",
    "data-name": "Group 51011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143259",
    "data-name": "Path 143259",
    d: "M389.076,139.561l-22.482-4.869-1.324,3.227s24.807,14.762,27.131,14.038S389.076,139.561,389.076,139.561Z",
    transform: "translate(-329.407 -71.745)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143260",
    "data-name": "Path 143260",
    d: "M411.691,248.589a2,2,0,0,1,.356,2.136l-.006.011c-.515,1.424-2.217,3.014-4.2,4.6-.253.2-.477.39-.673.561-.052.045-.1.09-.151.136s-.079.071-.116.1c-1.844,1.7-1.151,2.09-4.463,5.54-3.779,3.931-6.379,4-7.12,3.643-.626-.3.646-2.39,2.056-4.733.068-.113.136-.227.205-.342.188-.311.375-.628.561-.941,1.652-2.82,1.228-4.144.837-8.341-.319-3.41-5.306-19.054-5.306-19.054l7.24-1.247s2.18,12.457,4.582,14.375c1.285,1.022,2.722,1.035,3.957,1.793.088.053.174.106.258.163A9.5,9.5,0,0,1,411.691,248.589Z",
    transform: "translate(-331.581 -79.091)",
    fill: "#c18b63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143261",
    "data-name": "Path 143261",
    d: "M411.814,249.929a2,2,0,0,1,.356,2.136l-.006.011c-.631,1.422-2.29,3-4.2,4.588-.249.208-.47.4-.666.576-.052.045-.1.09-.151.136s-.079.071-.116.1c-1.844,1.7-1.151,2.09-4.463,5.54-3.779,3.931-6.379,4-7.12,3.643-.626-.3.646-2.39,2.056-4.733a16.108,16.108,0,0,0,6.735-4.963c2.275-2.9,3.792-6.632,5.34-8.793.088.053.174.106.258.163A9.5,9.5,0,0,1,411.814,249.929Z",
    transform: "translate(-331.704 -80.431)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143262",
    "data-name": "Path 143262",
    d: "M348.165,243.884c-.447,2.235-3.633,1.862-7.192.993s-2.713.163-7.778-.4-6.6-2.449-6.754-3.2c-.139-.668,2.364-.9,5.049-1.213.338-.038.677-.079,1.016-.121,3.032-.38,5.251-2.336,8-3.942,2.608-1.522,6.5-7.721,6.5-7.721l6.946.55s-3.645,5.537-5.055,7.945a8.392,8.392,0,0,0-.682,4.734A8.947,8.947,0,0,1,348.165,243.884Z",
    transform: "translate(-326.435 -78.908)",
    fill: "#c18b63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143263",
    "data-name": "Path 143263",
    d: "M340.973,245.853c-3.559-.87-2.713.163-7.778-.4s-6.6-2.449-6.754-3.2c-.139-.668,2.364-.9,5.049-1.213l.026.052a14.272,14.272,0,0,0,7.254,2.255c3.436.083,7.076-.9,9.45-.863a8.947,8.947,0,0,1-.054,2.376C347.718,247.1,344.532,246.722,340.973,245.853Z",
    transform: "translate(-326.435 -79.885)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143264",
    "data-name": "Path 143264",
    d: "M365.738,134.293s-1.656-4.055-3.476-4.22-7.614-1.076-8.028-.248a5.725,5.725,0,0,0,1.242,4.882c1.241,1.076,8.937,2.814,8.937,2.814Z",
    transform: "translate(-328.551 -71.346)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143265",
    "data-name": "Path 143265",
    d: "M378.793,196.154l14.971,40.291a13.713,13.713,0,0,0,4.506-.413,19.4,19.4,0,0,0,4.354-2.12s-3.714-38.686-10.523-46.733S378.793,196.154,378.793,196.154Z",
    transform: "translate(-330.443 -75.597)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143266",
    "data-name": "Path 143266",
    d: "M435.373,178.442S392.354,163.9,382.76,166.991s-38.4,60.406-38.4,60.406a5.561,5.561,0,0,0,2.424,1.53c1.651.619,5.646.579,5.646.579s26-22.283,29.092-28.781,4.333-12.689,7.428-12.071,39.923,15.165,48.279,6.5,6.171-19.925,6.171-19.925Z",
    transform: "translate(-327.807 -74.184)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143267",
    "data-name": "Path 143267",
    d: "M414.111,103.116c-.687-1.418-1.455-3.938-1.831-8.428.058.446.832,6.11,3.01,9.316,8.946,5.874,26.1,25.487,25.755,29.2,0,0,6.04-10.245,6.145-10.306,0,0,11.142-14.169-2.064-22.284-6.711-4.125-6.678-9.419-6.4-14.017s-1.83-24.4-15.275-19.215a8.747,8.747,0,0,0-3.124-.814,2.638,2.638,0,0,1,1.191.565,10.429,10.429,0,0,0-5.647,1.08C410.946,71.016,406.535,96.144,414.111,103.116Z",
    transform: "translate(-332.834 -66.528)",
    fill: "#644638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143268",
    "data-name": "Path 143268",
    d: "M416.3,106.329c-.045.02,4.32,2.286,7.6,1.388,3.088-.842,5.106-4.845,5.063-4.855-1.308-.259-1.684-2.057-1.657-9.779l-.591.116-9.941,1.969s.226,3.128.233,6.075C417.016,103.718,416.865,106.065,416.3,106.329Z",
    transform: "translate(-333.313 -68.56)",
    fill: "#c18b63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143269",
    "data-name": "Path 143269",
    d: "M416.815,95.178s.226,3.128.233,6.075c5.563-.157,8.5-5.231,9.708-8.044Z",
    transform: "translate(-333.353 -68.57)",
    fill: "#a17452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143270",
    "data-name": "Path 143270",
    d: "M427.263,90.344s2.915-4.605,3.615-8.544c.5-2.812-.933-13.234-11.407-11.733a14.233,14.233,0,0,0-5.9,2.231c-2.275,1.536-5.556,4.852-1.887,13.946l.953,3.072Z",
    transform: "translate(-332.834 -66.787)",
    fill: "#644638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143271",
    "data-name": "Path 143271",
    d: "M414.441,96.522s13.16.217,13.169-7.981,1.714-13.691-6.689-14.176-10.039,2.641-10.708,5.376S411.017,96.255,414.441,96.522Z",
    transform: "translate(-332.835 -67.124)",
    fill: "#c18b63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143272",
    "data-name": "Path 143272",
    d: "M415.331,73.986s3.6,9.618,9.134,11.04,7.929-.059,7.929-.059a52.671,52.671,0,0,1-2.9-10.83S418.05,69.408,415.331,73.986Z",
    transform: "translate(-333.239 -66.946)",
    fill: "#644638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143273",
    "data-name": "Path 143273",
    d: "M415.746,74.867s-2.691,2.147-3.347,4.235-.951,6.385-2.2,6.239c0,0-2.715-6.537.336-10.236C413.766,71.184,415.746,74.867,415.746,74.867Z",
    transform: "translate(-332.761 -67.046)",
    fill: "#644638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143274",
    "data-name": "Path 143274",
    d: "M443.456,142.546c1.3-5.443-3.118-16.005-7.727-24.75-4.182-7.925-8.524-14.355-8.914-14.123-11.031,6.546-12.027,1.1-12.027,1.1h0s-10.02,1.33-12.856,6.213c-3.519,6.06-7.321,22.992-11.1,26.2.58,1.775.332,2.721-.284,4.919q-.2.708-.437,1.344a25.8,25.8,0,0,1-1.9,3.893c1.92,1.166,5.627,3.385,8.358,1.79,4.164-2.436,7.412-9.855,9.24-12.809l.02-.033c3.975,22.5-1.43,27.618,1.306,29.99,2.889,2.5,7.016-1.192,16.095,2.742,5.954,2.584,14.218,6.318,19.781,6.968,2.918.343,5.095-.165,5.8-2.136C450.884,168.129,440.98,152.923,443.456,142.546Z",
    transform: "translate(-331.164 -69.37)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143276",
    "data-name": "Path 143276",
    d: "M451.68,175.867c-.71,1.971-2.887,2.479-5.8,2.136-3.85-1.678-20.482-8.122-20.3-12.487.276-6.465,3.2-6.671,1.135-14.65-1.657-6.407,13.712-18.32,16.162-20.909,4.61,8.744,4.737,9.158,3.439,14.6C443.839,154.935,453.743,170.141,451.68,175.867Z",
    transform: "translate(-334.023 -71.383)",
    fill: "#8caf84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143277",
    "data-name": "Path 143277",
    d: "M453.9,150.54a24.39,24.39,0,0,0-8.044-7.434c.465-1.2-12.407-16.98-12.407-19.425,0-2.476-3.434-20.01-3.434-20.01s10.725.662,14.438,5.841C449.1,115.99,458.743,140.916,453.9,150.54Z",
    transform: "translate(-334.363 -69.371)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143278",
    "data-name": "Path 143278",
    d: "M445.393,146.375l-21.434,5.592,2.012,3.611s26.083-.182,27.466-1.769S445.393,146.375,445.393,146.375Z",
    transform: "translate(-333.9 -72.639)",
    fill: "#c18b63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143279",
    "data-name": "Path 143279",
    d: "M405.814,139.03c-1.828,2.954-5.076,10.373-9.24,12.809-2.732,1.6-6.438-.623-8.358-1.79a25.8,25.8,0,0,0,1.9-3.893c1.532.351,3.4.8,4.607,1.163C397.066,148.029,405.814,139.03,405.814,139.03Z",
    transform: "translate(-331.164 -72.077)",
    fill: "#8caf84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143280",
    "data-name": "Path 143280",
    d: "M422.738,152.3s-6.731-1.9-8.334-1.459-7.1,4.083-6.324,5.07,5.612-.591,7.838-.293,3.949,1.4,5.552,1.161a18.59,18.59,0,0,0,3.28-.868Z",
    transform: "translate(-332.678 -72.976)",
    fill: "#c18b63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143281",
    "data-name": "Path 143281",
    d: "M423.557,152.2a25.206,25.206,0,0,1-4.229-2.655.263.263,0,0,0-.409.047c-.251.4-.486,1.161.669,1.921A6.217,6.217,0,0,0,423.557,152.2Z",
    transform: "translate(-333.498 -72.876)",
    fill: "#c18b63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51013",
    "data-name": "Group 51013",
    transform: "translate(9.779 54.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143282",
    "data-name": "Path 143282",
    d: "M390.276,162.479h31.4a2.5,2.5,0,0,0-2.5-2.5h-28.9Z",
    transform: "translate(-341.1 -128.278)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143283",
    "data-name": "Path 143283",
    d: "M386.349,125.651H337.8l11.645,34.2H398.31Z",
    transform: "translate(-337.084 -125.651)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143284",
    "data-name": "Path 143284",
    d: "M337.025,125.651l11.647,34.2h48.863l-11.96-34.2Z",
    transform: "translate(-337.025 -125.651)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143285",
    "data-name": "Path 143285",
    d: "M365.365,143.63A3.157,3.157,0,0,0,368.277,146a1.821,1.821,0,0,0,1.819-2.366,3.155,3.155,0,0,0-2.912-2.366A1.822,1.822,0,0,0,365.365,143.63Z",
    transform: "translate(-339.189 -126.846)",
    fill: "#ffe1d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143286",
    "data-name": "Path 143286",
    d: "M337.025,125.651l11.647,34.2h32.36c-21.436-7.316-27.142-29.625-28.1-34.2Z",
    transform: "translate(-337.025 -125.651)",
    fill: "#ea742e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51016",
    "data-name": "Group 51016",
    transform: "translate(141.056 94.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51015",
    "data-name": "Group 51015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143287",
    "data-name": "Path 143287",
    d: "M488.115,267.764a1.254,1.254,0,0,1-1.244-1.02l-6.1-34.562L472,182.473l-2.453-13.9,6.247-.178,1.084,8.069,7.61,56.7L489,266.78A.88.88,0,0,1,488.115,267.764Z",
    transform: "translate(-469.55 -168.395)",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143288",
    "data-name": "Path 143288",
    d: "M476.881,176.464A8.962,8.962,0,0,0,472,182.473l-2.453-13.9,6.247-.178Z",
    transform: "translate(-469.55 -168.395)",
    fill: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51018",
    "data-name": "Group 51018",
    transform: "translate(3.341 94.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51017",
    "data-name": "Group 51017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143289",
    "data-name": "Path 143289",
    d: "M321.317,267.764a1.255,1.255,0,0,0,1.244-1.02l6.1-34.562,8.771-49.708,2.453-13.9-6.247-.178-1.084,8.069-7.61,56.7-4.512,33.612A.88.88,0,0,0,321.317,267.764Z",
    transform: "translate(-320.421 -168.395)",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143290",
    "data-name": "Path 143290",
    d: "M333.556,176.464a8.962,8.962,0,0,1,4.879,6.009l2.453-13.9-6.247-.178Z",
    transform: "translate(-321.426 -168.395)",
    fill: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29096",
    "data-name": "Rectangle 29096",
    d: "M3.81,0H163.789A3.811,3.811,0,0,1,167.6,3.811V7.1a3.811,3.811,0,0,1-3.811,3.811H3.811A3.811,3.811,0,0,1,0,7.1V3.81A3.81,3.81,0,0,1,3.81,0Z",
    transform: "translate(0 88.791)",
    fill: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51023",
    "data-name": "Group 51023",
    transform: "translate(73.808 32.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51020",
    "data-name": "Group 51020"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29097",
    "data-name": "Rectangle 29097",
    width: 175.203,
    height: 109.804,
    transform: "translate(176.204 110.792) rotate(179.994)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143291",
    "data-name": "Path 143291",
    d: "M79.938,147.035l-.013-111.78,177.18-.018.013,111.78ZM81.9,37.231l.013,107.828,173.227-.018-.013-107.829Z",
    transform: "translate(-79.925 -35.236)",
    fill: "#66c8ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51022",
    "data-name": "Group 51022",
    transform: "translate(60.198 45.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51021",
    "data-name": "Group 51021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143292",
    "data-name": "Path 143292",
    d: "M200.735,90.895l-39.35.007a2.248,2.248,0,0,1-2.248-2.247h0a2.247,2.247,0,0,1,2.247-2.247l39.35-.007a2.246,2.246,0,0,1,2.247,2.246h0A2.246,2.246,0,0,1,200.735,90.895Z",
    transform: "translate(-146.186 -85.124)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143293",
    "data-name": "Path 143293",
    d: "M200.736,105.2l-39.35.008a2.247,2.247,0,0,1-2.247-2.247h0a2.248,2.248,0,0,1,2.247-2.248l39.35-.007a2.246,2.246,0,0,1,2.247,2.247h0A2.246,2.246,0,0,1,200.736,105.2Z",
    transform: "translate(-146.186 -86.219)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143294",
    "data-name": "Path 143294",
    d: "M149.563,93.169h-.375a4.076,4.076,0,0,1-4.076-4.075h0a4.075,4.075,0,0,1,4.075-4.076h.375a4.076,4.076,0,0,1,4.076,4.075h0A4.077,4.077,0,0,1,149.563,93.169Z",
    transform: "translate(-145.112 -85.018)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29098",
    "data-name": "Rectangle 29098",
    width: 8.526,
    height: 8.151,
    rx: 4.076,
    transform: "translate(0.001 11.704)",
    fill: "#ff7f32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ring_Chart9",
    "data-name": "Ring Chart9",
    transform: "translate(43.79 11.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93256",
    "data-name": "Path 93256",
    d: "M175.865,47.248a44.807,44.807,0,0,1,44.806,44.806h-5.049A39.758,39.758,0,0,0,175.865,52.3Z",
    transform: "translate(-131.058 -47.248)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93257",
    "data-name": "Path 93257",
    d: "M216.958,92.054a44.807,44.807,0,1,1-44.806-44.806V52.3a39.758,39.758,0,1,0,39.758,39.758Z",
    transform: "translate(-127.344 -47.248)",
    fill: "#ff7f32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51026",
    "data-name": "Group 51026",
    transform: "translate(0 122.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51024",
    "data-name": "Group 51024",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20818",
    "data-name": "Rectangle 20818",
    width: 175.577,
    height: 49.8,
    rx: 5.946,
    transform: "translate(0)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20818-2",
    "data-name": "Rectangle 20818",
    d: "M169.63,133.723a3.98,3.98,0,0,1,3.975,3.975v37.907a3.98,3.98,0,0,1-3.975,3.975H5.946a3.98,3.98,0,0,1-3.975-3.975V137.7a3.98,3.98,0,0,1,3.975-3.975H169.63m0-1.971H5.946A5.946,5.946,0,0,0,0,137.7v37.907a5.946,5.946,0,0,0,5.946,5.946H169.63a5.947,5.947,0,0,0,5.947-5.946V137.7a5.947,5.947,0,0,0-5.947-5.946Z",
    transform: "translate(0 -131.752)",
    fill: "#66c8ec"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97232",
    "data-name": "Path 97232",
    d: "M166.156,163.335a.968.968,0,0,0,1.37,0h0l7.836-7.842a.968.968,0,0,0,0-1.369h0l-.9-.914a.969.969,0,0,0-1.368,0l-6.251,6.213-6.244-6.215a.969.969,0,0,0-1.368,0l-.911.916a.968.968,0,0,0,0,1.369h0Z",
    transform: "translate(-12.096 -133.372)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51025",
    "data-name": "Group 51025",
    transform: "translate(35.393 14.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29099",
    "data-name": "Rectangle 29099",
    width: 43.787,
    height: 6.689,
    rx: 3.345,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29100",
    "data-name": "Rectangle 29100",
    width: 91.548,
    height: 9.624,
    rx: 4.812,
    transform: "translate(0 11.931)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "user-solid",
    d: "M9.43,10.778A5.389,5.389,0,1,0,4.042,5.389,5.388,5.388,0,0,0,9.43,10.778ZM7.506,12.8A7.5,7.5,0,0,0,0,20.3a1.251,1.251,0,0,0,1.25,1.25H17.61a1.251,1.251,0,0,0,1.25-1.25A7.5,7.5,0,0,0,11.354,12.8Z",
    transform: "translate(9.947 14.122)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51029",
    "data-name": "Group 51029",
    transform: "translate(96.04 164.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51027",
    "data-name": "Group 51027"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20818-3",
    "data-name": "Rectangle 20818",
    width: 175.577,
    height: 49.8,
    rx: 5.946,
    transform: "translate(0)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20818-4",
    "data-name": "Rectangle 20818",
    d: "M273.63,179.723a3.98,3.98,0,0,1,3.975,3.975v37.907a3.98,3.98,0,0,1-3.975,3.975H109.946a3.98,3.98,0,0,1-3.975-3.975V183.7a3.98,3.98,0,0,1,3.975-3.975H273.63m0-1.971H109.946A5.946,5.946,0,0,0,104,183.7v37.907a5.946,5.946,0,0,0,5.946,5.946H273.63a5.947,5.947,0,0,0,5.947-5.946V183.7a5.947,5.947,0,0,0-5.947-5.946Z",
    transform: "translate(-104 -177.752)",
    fill: "#66c8ec"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97232-2",
    "data-name": "Path 97232",
    d: "M270.156,209.335a.968.968,0,0,0,1.37,0h0l7.837-7.842a.968.968,0,0,0,0-1.369h0l-.9-.914a.969.969,0,0,0-1.368,0l-6.251,6.213-6.244-6.215a.969.969,0,0,0-1.368,0l-.911.916a.968.968,0,0,0,0,1.369h0Z",
    transform: "translate(-116.096 -179.372)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51028",
    "data-name": "Group 51028",
    transform: "translate(39.781 14.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29101",
    "data-name": "Rectangle 29101",
    width: 43.787,
    height: 6.689,
    rx: 3.345,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29102",
    "data-name": "Rectangle 29102",
    width: 91.548,
    height: 9.624,
    rx: 4.812,
    transform: "translate(0 11.931)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "user-solid-2",
    "data-name": "user-solid",
    d: "M9.43,10.778A5.389,5.389,0,1,0,4.042,5.389,5.388,5.388,0,0,0,9.43,10.778ZM7.506,12.8A7.5,7.5,0,0,0,0,20.3a1.251,1.251,0,0,0,1.25,1.25H17.61a1.251,1.251,0,0,0,1.25-1.25A7.5,7.5,0,0,0,11.354,12.8Z",
    transform: "translate(12.907 14.122)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97654",
    "data-name": "Path 97654",
    d: "M231.781,237.418a1.277,1.277,0,0,1-1.191.826H225l2.4,5.042a2.127,2.127,0,0,1-3.841,1.829l-2.477-5.209L217.1,244.6a1.275,1.275,0,0,1-.972.449,1.306,1.306,0,0,1-.44-.078,1.291,1.291,0,0,1-.838-1.246V224.2a1.271,1.271,0,0,1,2.112-.959l14.418,12.763a1.288,1.288,0,0,1,.4,1.409Z",
    transform: "translate(-16.444 -16.613)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143295",
    "data-name": "Path 143295",
    d: "M50.266,202.083c.629,13.953,11.787,26.731,25.528,29.234a9.846,9.846,0,0,0,6.215-.438c1.885-.959,3.168-3.358,2.256-5.266a4.033,4.033,0,0,0-4.8-1.773,7.167,7.167,0,0,0-3.961,3.722c-2.7,5.23-1.085,11.929,2.712,16.426,4.818,5.7,11.117,7.833,15.017,8.8,19.745,4.9,35.137-5.058,41.6-11.522",
    transform: "translate(-3.847 -15.017)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.847,
    strokeDasharray: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersPageArtWork);
export default __webpack_public_path__ + "static/media/UsersPageArtWork.99554c5f11c22a19692b140432fecfbe.svg";
export { ForwardRef as ReactComponent };